import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { T } from 'components/Translations'
import Icon from 'components/Icon'

import { canUpgrade } from 'utils'
import { buttonType } from 'common/types'
import StyledButton from './StyledButton'

const Button = ({ to, onClick, color, fill, size, label, icon, children, countdown, ...props }) => {
  onClick = onClick || (props.disabled ? e => e.preventDefault() : null)
  const linkProps = to ? { to, as: Link } : {}

  return (
    <StyledButton {...{ onClick, color, fill, size, ...props, ...linkProps }}>
      {label ? <T label={label} /> : icon ? <Icon name={icon} /> : children}
      {countdown}
    </StyledButton>
  )
}

Button.propTypes = buttonType

Button.defaultProps = {
  color: 'main',
  fill: 'filled',
  size: 'medium',
  type: 'button',
  disabled: false,
}

const UpgradeButtonBasic = ({ canUpgrade, to = '/payment/upgrade', ...props }) =>
  !canUpgrade || <Button color="cta" label="actions/upgrade" to={to} {...props} />

export const UpgradeButton = connect(
  ({ myProfile, flags }) => ({
    canUpgrade: canUpgrade({ myProfile, flags }),
  }),
  {}
)(UpgradeButtonBasic)

export const UpdateButton = props => (
  <Button type="submit" fill="filled" color="highlight" label="actions/update" {...props} />
)

export default Button
